import { render, staticRenderFns } from "./MappingRecordsPanel.vue?vue&type=template&id=1d6dfbc8&scoped=true"
import script from "./MappingRecordsPanel.vue?vue&type=script&lang=js"
export * from "./MappingRecordsPanel.vue?vue&type=script&lang=js"
import style0 from "./MappingRecordsPanel.vue?vue&type=style&index=0&id=1d6dfbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6dfbc8",
  null
  
)

export default component.exports